import { useAuth0 } from "@auth0/auth0-react";
import { useSuspenseQuery } from "@tanstack/react-query";
import client from "api/client";
import api from "api/index";


export const query = {
	auth0: (auth0: ReturnType<typeof useAuth0>) => ({
		queryKey: ["auth0"],
		queryFn: async () => {
			if (auth0.isAuthenticated) {
				try {
					const token = await auth0.getAccessTokenSilently();
					client.setAuthTokenProvider(() => token);
					return token;
				} catch (e: unknown) {
					if (e instanceof Error && e.message === "Login required") {
						await auth0.loginWithRedirect();
						return null;
					}
					throw e;
				}
			}
			return null;
		}
	}),
	status: {
		queryKey: ["status"],
		queryFn: api.partner.status
	}
};

export const useQueryStart = () => {
	return useSuspenseQuery({
		queryKey: ["start"],
		queryFn: api.start.get,
		staleTime: Infinity
	});
};

export const useQueryAuth0 = () => {
	const auth0 = useAuth0();

	return useSuspenseQuery(query.auth0(auth0));
};

export const useQueryStatus = () => {
	return useSuspenseQuery(query.status);
};